const id_purch_poMitra = {

}

export default id_purch_poMitra;